import { defineStore } from "pinia";
import { createStore } from "./storeHelper";

// Migration helper to load old Vuex persisted state
const migrateFromVuex = () => {
  try {
    // Check if new Pinia state already exists
    const piniaState = localStorage.getItem("appLocal");
    if (piniaState) {
      return null; // Already migrated or fresh install
    }

    // Check for old Vuex state
    const vuexState = localStorage.getItem("vuex");
    if (vuexState) {
      const parsed = JSON.parse(vuexState);
      const oldAppLocal = parsed.appLocal;

      if (oldAppLocal && typeof oldAppLocal === "object") {
        console.log("Migrating appLocal state from Vuex to Pinia");

        // Save to new Pinia format
        localStorage.setItem("appLocal", JSON.stringify(oldAppLocal));

        // Optionally remove old state (uncomment if desired)
        // localStorage.removeItem('vuex');

        return oldAppLocal;
      }
    }
  } catch (error) {
    console.warn("Failed to migrate appLocal state from Vuex:", error);
  }

  return null;
};

export const useAppLocalStore = defineStore(
  "appLocal",
  createStore({
    state: () => {
      // Try to migrate old state first, then fall back to defaults
      const migratedState = migrateFromVuex();
      return (
        migratedState || {
          announcement_list_selected_collection_ids: [],
        }
      );
    },

    actions: {
      clearLocalData() {
        this.announcement_list_selected_collection_ids = [];
      },
    },

    persist: true, // This will persist the entire store to localStorage
  }),
);
